import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Picker, SystemText } from 'e4shared';
import { load, add, update, remove } from 'actions/admin';
import { setShowSuccess } from 'actions/ui';
import SimpleAdmin, { DefaultOptions } from 'components/simpleAdmin';
import BlobImage from 'components/blobImage';

export const AdminBusinessUnits = ({ history, ...props }) => {
    const dispatch = useDispatch();
    const [pickerItem, setPickerItem] = useState();
    const [showPicker, setShowPicker] = useState();

    const data = useSelector(state => state.admin.businessUnits);
    const admin = useSelector(state => state.user.user?.sys_Config);
    const activeUsers = useSelector(state => state.admin.profiles?.filter(p => p.active));

    const onLoad = () => {
        dispatch(load('business-unit'));
    };

    const onLoadActiveUsers = () => {
        dispatch(load('profile'));
    };

    const onAdd = (entity, callback) => {
        dispatch(add('business-unit', entity, null, callback));
    };

    const onUpdate = (entity, callback) => {
        dispatch(update('business-unit', entity, null, callback));
    };

    const onRemove = (ids, callback) => {
        if (!Array.isArray(ids)) ids = [ids];
        ids.forEach((id, idx) => {
            dispatch(remove('business-unit', id, () => idx + 1 === ids.length && callback()));
        });
    };
    useEffect(() => {
        onLoad();
        onLoadActiveUsers();
    }, []);

    if (!admin) history.replace('/');

    const options = {
        ...DefaultOptions(),
        label: SystemText('Admin/BusinessUnit/Label/Options'),
    };

    const fields = [
        {
            label: SystemText('Admin/BusinessUnit/Fields/Label/Name'),
            type: 'text',
            dataProperty: 'name',
            mandatory: true,
            maxLength: 50,
            generalErrors: true,
            uniqueErrors: true,
            help: SystemText('Admin/BusinessUnit/Fields/Help/Name'),
        },
        {
            label: SystemText('Admin/BusinessUnit/Fields/Label/Parent'),
            help: SystemText('Admin/BusinessUnit/Fields/Help/Parent'),
            type: 'select',
            dataProperty: 'parent_Id',
            isTree: true,
            data: [...data],
            dataBlock: 'id',
            allowMultiple: false,
            placeholder: SystemText('Admin/BusinessUnit/Fields/Placeholder/Parent'),
        },
        {
            label: SystemText('Admin/BusinessUnit/Fields/Label/Benchmarks'),
            type: 'toggle',
            mandatory: false,
            dataProperty: 'show_Benchmarks',
            help: SystemText('Admin/BusinessUnit/Fields/Help/Benchmarks'),
            inTitleBar: true,
        },
    ];

    const tableColumns = [
        { label: SystemText('Admin/BusinessUnit/Table/Columns/Label/Name'), dataProperty: 'name' },
        { label: SystemText('Admin/BusinessUnit/Table/Columns/Label/Parent'), dataProperty: 'parent' },
        {
            label: SystemText('Admin/BusinessUnit/Table/Columns/Label/Users'),
            dataProperty: 'staff_Ids',
            showCount: true,
            onClick: item => {
                setPickerItem(item);
                setShowPicker(true);
            },
        },
    ];

    return (
        <div data-testid="businessunit-wrapper-testid">
            <SimpleAdmin
                {...props}
                add={onAdd}
                load={onLoad}
                update={onUpdate}
                remove={onRemove}
                data={data}
                fields={fields}
                options={options}
                columns={tableColumns}
                defaultValues={{ show_Benchmarks: true }}
            />
            <Picker
                title={SystemText('Admin/BusinessUnit/Pickers/Title/Users', pickerItem?.name)}
                help={SystemText('Admin/BusinessUnit/Pickers/Help/Users')}
                entity={SystemText('Admin/BusinessUnit/Pickers/Entity/Users')}
                data={activeUsers}
                nameProperty="full_Name"
                filterOption="staff"
                value={pickerItem?.staff_Ids}
                show={showPicker}
                onSave={ids => {
                    onUpdate({ ...pickerItem, update_Staff_Ids: ids }, () => {
                        dispatch(setShowSuccess(SystemText('Admin/BusinessUnit/ShowSuccess/SaveUsers')));
                        setShowPicker(false);
                        dispatch(load('business-unit'));
                    });
                }}
                onClose={() => {
                    setShowPicker(false);
                    setPickerItem(null);
                }}
                itemPrefix={p => (
                    <div className="image-holder mr10">
                        <BlobImage folder="avatar" src={p.avatar} />
                    </div>
                )}
            />
        </div>
    );
};

export default AdminBusinessUnits;
